// Exemplo Capelania - Solicitação de Visita Religiosa HC-UFU
export const CAPELANIA_EXAMPLE = {
  name: "Solicitação de Visita Religiosa - HC-UFU",
  url: "capelania",
  type: "form",
  logo: "https://www.gov.br/hubrasil/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/ensino-e-pesquisa/solicitacao-de-servicos/solicitacao-de-visita-religiosa-1/logo_capelania.png/@@images/image",
  formConfig: {
    title: "Solicitação de Visita Religiosa",
    subtitle: "Estamos aqui para proporcionar conforto espiritual neste momento",
    urgentPhone: "(34) 3218-2064",
    email: "capelaniahos.hc-ufu@hubrasil.gov.br",
    successMessage: "Sua solicitação foi registrada com sucesso!",
    settings: {
      showProgressBar: true,
      requireConfirmation: true,
      generateProtocol: true,
      sendEmail: true,
      emailRecipients: ["capelaniahos.hc-ufu@hubrasil.gov.br"],
      navigationMode: "linear"
    },
    steps: [
      {
        id: "inicio",
        title: "Bem-vindo",
        description: "Canal de atendimento para solicitação de visita religiosa\nCapelania do HC-UFU/HU BRASIL",
        icon: "FileText",
        type: "form",
        level: 0,
        fields: [
          {
            id: "inicio-info",
            type: "info",
            label: "Atendimento Urgente?",
            description: "Ligue para: (34) 3218-2064",
            icon: "Phone",
            style: { variant: "large" },
            order: 0
          }
        ],
        navigation: {
          showPrevious: false,
          nextButtonText: "Deseja solicitar visita religiosa?"
        },
        order: 0
      },
      {
        id: "religiao",
        title: "Qual a religião do paciente?",
        description: "Selecione a religião para direcionarmos o atendimento adequado",
        icon: "Star",
        type: "form",
        level: 0,
        fields: [
          {
            id: "religiao",
            type: "button",
            label: "Selecione a religião",
            required: true,
            options: [
              { value: "catolica", label: "Católica", icon: "Home" },
              { value: "evangelica", label: "Evangélica/Protestante", icon: "Book" },
              { value: "espirita", label: "Espírita", icon: "Star" },
              { value: "islamica", label: "Islâmica", icon: "Moon" },
              { value: "judaica", label: "Judaica", icon: "Star" },
              { value: "budista", label: "Budista", icon: "Sun" },
              { value: "umbanda", label: "Umbanda/Candomblé", icon: "Shield" },
              { value: "outra", label: "Outra religião", icon: "Heart" }
            ],
            style: { variant: "card" },
            order: 0
          },
          {
            id: "outraReligiao",
            type: "text",
            label: "Especifique a religião",
            placeholder: "Nome da religião",
            required: true,
            conditional: {
              show: true,
              when: "religiao",
              equals: "outra"
            },
            order: 1
          }
        ],
        order: 1
      },
      {
        id: "tipo-atendimento",
        title: "Tipo de atendimento desejado",
        description: "Selecione os serviços religiosos que deseja",
        icon: "Heart",
        type: "form",
        level: 0,
        fields: [
          {
            id: "tiposAtendimento",
            type: "checkbox",
            label: "Selecione um ou mais serviços",
            required: true,
            options: [
              { value: "visita", label: "Visita de conforto espiritual", icon: "Heart" },
              { value: "oracao", label: "Oração específica", icon: "Users" },
              { value: "comunhao", label: "Comunhão", icon: "Gift" },
              { value: "confissao", label: "Confissão", icon: "MessageCircle" },
              { value: "uncao", label: "Unção dos Enfermos", icon: "Shield" }
            ],
            order: 0
          }
        ],
        order: 2
      },
      {
        id: "lider-religioso",
        title: "Escolha do líder religioso",
        description: "Você tem preferência por algum líder religioso específico?",
        icon: "User",
        type: "form",
        level: 0,
        fields: [
          {
            id: "temLiderProprio",
            type: "radio",
            label: "Quem realizará a visita?",
            required: true,
            options: [
              { 
                value: "false", 
                label: "Aceito um capelão do hospital",
                description: "Um de nossos capelães realizará a visita"
              },
              { 
                value: "true", 
                label: "Tenho meu líder religioso",
                description: "Trarei meu próprio líder para a visita"
              }
            ],
            style: { variant: "card" },
            order: 0
          },
          {
            id: "lider-info",
            type: "info",
            label: "Importante",
            description: "É OBRIGATÓRIA a apresentação de documento com foto na portaria",
            icon: "AlertCircle",
            conditional: {
              show: true,
              when: "temLiderProprio",
              equals: "true"
            },
            order: 1
          },
          {
            id: "nomeLider",
            type: "text",
            label: "Nome do líder religioso",
            placeholder: "Nome completo",
            required: true,
            conditional: {
              show: true,
              when: "temLiderProprio",
              equals: "true"
            },
            order: 2
          },
          {
            id: "instituicaoReligiosa",
            type: "text",
            label: "Instituição religiosa",
            placeholder: "Nome da igreja/templo",
            required: true,
            conditional: {
              show: true,
              when: "temLiderProprio",
              equals: "true"
            },
            order: 3
          }
        ],
        order: 3
      },
      {
        id: "dados",
        title: "Dados do paciente e solicitante",
        description: "Informações necessárias para a visita",
        icon: "Users",
        type: "form",
        level: 0,
        fields: [
          {
            id: "dados-paciente",
            type: "section",
            label: "Dados do Paciente",
            order: 0
          },
          {
            id: "nomePaciente",
            type: "text",
            label: "Nome do paciente",
            placeholder: "Nome completo",
            required: true,
            style: { width: "full" },
            order: 1
          },
          {
            id: "numeroLeito",
            type: "text",
            label: "Número do leito",
            placeholder: "Ex: 101",
            required: true,
            style: { width: "quarter" },
            order: 2
          },
          {
            id: "setorInternacao",
            type: "select",
            label: "Setor de internação",
            required: true,
            options: [
              { value: "1", label: "Internação Pronto Socorro" },
              { value: "2", label: "Enfermarias" },
              { value: "3", label: "UTIs" }
            ],
            style: { width: "half" },
            order: 3
          },
          {
            id: "subSetor",
            type: "select",
            label: "Local específico",
            required: true,
            options: [
              { value: "quartao-fem", label: "Quartão Feminino" },
              { value: "quartao-masc", label: "Quartão Masculino" },
              { value: "sala-vermelha", label: "Sala Vermelha" }
            ],
            conditional: {
              show: true,
              when: "setorInternacao",
              equals: "1"
            },
            style: { width: "half" },
            order: 4
          },
          {
            id: "dados-solicitante",
            type: "section",
            label: "Dados do Solicitante",
            order: 5
          },
          {
            id: "nomeSolicitante",
            type: "text",
            label: "Seu nome completo",
            placeholder: "Nome completo",
            required: true,
            order: 6
          },
          {
            id: "whatsappSolicitante",
            type: "phone",
            label: "WhatsApp",
            placeholder: "(34) 9.9999-9999",
            required: true,
            style: { width: "half" },
            order: 7
          },
          {
            id: "emailSolicitante",
            type: "email",
            label: "Email",
            placeholder: "seu@email.com",
            style: { width: "half" },
            order: 8
          },
          {
            id: "relacaoComPaciente",
            type: "select",
            label: "Relação com o paciente",
            required: true,
            options: [
              { value: "paciente", label: "Sou o paciente" },
              { value: "familiar", label: "Familiar" },
              { value: "amigo", label: "Amigo" },
              { value: "outro", label: "Outro" }
            ],
            order: 9
          }
        ],
        order: 4
      },
      {
        id: "agendamento",
        title: "Quando deseja a visita?",
        description: "Escolha entre atendimento urgente ou agende uma data",
        icon: "Calendar",
        type: "form",
        level: 0,
        fields: [
          {
            id: "tipoAgendamento",
            type: "button",
            label: "Tipo de agendamento",
            required: true,
            options: [
              { 
                value: "urgente", 
                label: "É URGENTE!",
                description: "Necessito de atendimento o mais breve possível",
                icon: "AlertCircle"
              },
              { 
                value: "agendado", 
                label: "Agendar Data",
                description: "Prefiro escolher um dia específico",
                icon: "Calendar"
              }
            ],
            style: { variant: "card" },
            order: 0
          },
          {
            id: "agendamento-info",
            type: "info",
            label: "Horário de visita",
            description: "13:00 às 13:30. Agendamentos para fim de semana devem ser feitos até sexta-feira às 16h",
            icon: "Clock",
            conditional: {
              show: true,
              when: "tipoAgendamento",
              equals: "agendado"
            },
            order: 1
          },
          {
            id: "dataVisita",
            type: "date",
            label: "Escolha a data",
            required: true,
            conditional: {
              show: true,
              when: "tipoAgendamento",
              equals: "agendado"
            },
            validation: {
              min: 1
            },
            order: 2
          }
        ],
        order: 5
      },
      {
        id: "confirmacao",
        title: "Confirme os dados da solicitação",
        description: "Revise as informações antes de enviar",
        icon: "CheckCircle",
        type: "form",
        level: 0,
        fields: [
          {
            id: "aceitoRegras",
            type: "checkbox",
            label: "",
            required: true,
            options: [
              { value: "aceito", label: "Li e aceito as regras de visita do hospital" }
            ],
            order: 0
          }
        ],
        navigation: {
          nextButtonText: "Enviar Solicitação"
        },
        order: 6
      }
    ]
  },
  theme: {
    // Cores principais
    primaryColor: "#7C8435", // Verde-oliva
    primaryColorHover: "#5F682A",
    secondaryColor: "#BA8221", // Dourado RGB(186,130,33)
    secondaryColorHover: "#9A6A1A",
    
    // Backgrounds
    pageBackground: "#041622", // Azul escuro RGB(4,22,34)
    cardBackground: "#0A1F2E", // Card azul escuro levemente mais claro
    inputBackground: "#FFFFFF",
    
    // Textos
    textPrimary: "#F0F0F0", // Texto claro para contraste
    textSecondary: "#BA8221", // Dourado para texto secundário
    textOnPrimary: "#FFFFFF",
    textOnSecondary: "#041622",
    
    // Bordas
    borderColor: "#7C8435",
    borderRadius: "8px",
    
    // Estados
    errorColor: "#e74c3c",
    successColor: "#27ae60",
    warningColor: "#BA8221",
    infoColor: "#3498db",
    
    // Botões
    buttonStyle: "rounded",
    buttonPadding: "14px 28px",
    buttonFontWeight: "700",
    
    // Fontes
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: "16px",
    headingFontFamily: null,
    headingFontWeight: "700",
    
    // Sombras
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
    boxShadowHover: "0 4px 16px rgba(0,0,0,0.4)",
    
    // Animações
    transitionDuration: "0.2s",
    
    // Progress Bar - DOURADA
    progressBarColor: "#BA8221", // Dourado
    progressBarBackground: "#0A1F2E", // Fundo escuro
    
    // Logo
    logoBackground: "transparent",
    logoPadding: "8px",
    logoBorderRadius: "8px",
    
    // Personalizações especiais para Capelania
    alertInfoBackground: "#BA8221", // Dourado para caixa de urgência
    alertInfoBorder: "#9A6A1A", // Dourado escuro para borda
    alertInfoTextColor: "#041622", // Texto preto na caixa dourada
    footerBackground: "#7C8435", // Rodapé verde oliva
    footerBorderColor: "#5F682A", // Borda verde escura
    footerTextColor: "#FFFFFF" // Texto branco no rodapé
  }
};